import { z } from 'zod';
/**
 * Signing and rejecting (REQUIREMENTS §2.5 "Sign", §2.10).
 *
 * The one interaction the app exists for. What the schema encodes of the
 * rules: signing is all-or-nothing (there is no per-line accept), a comment
 * may ride along with a signature, and a rejection must say why.
 *
 * What the schema cannot encode, and the server enforces: only the soldier
 * named on the form may sign it, in their own session. No commander, no admin, no override.
 */
/** A PNG the canvas produced, as a data URL. ~200 KB is generous for a signature. */
export const MAX_SIGNATURE_BYTES = 300 * 1024;
export const signFormRequestSchema = z.object({
    imageDataUrl: z
        .string()
        .regex(/^data:image\/png;base64,[A-Za-z0-9+/=]+$/, 'A PNG data URL is required')
        .max(Math.ceil((MAX_SIGNATURE_BYTES * 4) / 3) + 64),
    /** "scope has a cracked lens" — signed, but the commander is told (§2.5). */
    comment: z.string().trim().max(500).nullable().default(null),
});
export const rejectFormRequestSchema = z.object({
    reason: z.string().trim().min(3).max(500),
});
/**
 * The immutable record (§2.4 `signatures`). Never updated after creation.
 * The PDF and any future dispute are generated from `snapshot`, never from
 * live data.
 */
export const signatureSnapshotSchema = z.object({
    lineItems: z.array(z.object({
        catalogItemId: z.string(),
        inventoryUnitId: z.string().nullable(),
        quantity: z.number().int(),
        condition: z.string(),
        notes: z.string().nullable(),
    })),
    itemNames: z.array(z.object({ he: z.string(), en: z.string() })),
    serialNumbers: z.array(z.string().nullable()),
    quantities: z.array(z.number().int()),
    conditions: z.array(z.string()),
    issuedBy: z.string(),
    issuerName: z.string(),
    soldierName: z.string(),
    terms: z.string(),
});
export const signatureSchema = z.object({
    id: z.string().min(1),
    formId: z.string().min(1),
    soldierUid: z.string().min(1),
    imagePath: z.string().min(1),
    signedAt: z.string().nullable(),
    snapshot: signatureSnapshotSchema,
    comment: z.string().nullable(),
});
export const signatureResponseSchema = z.object({ signature: signatureSchema });
/** The handover terms the soldier signs under. Frozen into every snapshot. */
export const SIGNATURE_TERMS_HE = 'אני מאשר/ת קבלת הציוד המפורט לעיל ולוקח/ת אחריות אישית על שמירתו ותקינותו עד להחזרתו.';
export const SIGNATURE_TERMS_EN = 'I confirm receipt of the equipment listed above and take personal responsibility for its safekeeping and condition until its return.';
//# sourceMappingURL=sign.js.map